// extracted by mini-css-extract-plugin
export default {"aldCarousel":"Carousel_aldCarousel__ikJvu ald-carousel","buttons":"Carousel_buttons__d4+us","container":"Carousel_container__xQC9v","picture":"Carousel_picture__AkQbB"};